module.exports = __webpack_public_path__ + "static/NanumSquareEB-0029b8a5a16ce106b0bf5ac8ea23de04.woff";